import { clearReloads, sessionStore } from "@/platform/followBuild";
import { forceUpdate } from "@/platform/pwaUpdate";
import { useBuildNotice } from "@/services/buildFollow";

/**
 * What a client shows when it can't simply reload into the server's build (services/buildFollow.ts):
 * - stuck: two forced reloads didn't bring the new build; the game must not run on the old one;
 * - update: a native build on another protocol; it needs the store's update;
 * - banner: an admin page, never reloaded under an editor; save, then reload.
 */
export function BuildNotice() {
  const notice = useBuildNotice((s) => s.notice);
  if (notice === "none") return null;
  if (notice === "banner")
    return (
      <div className="build-banner" role="status">
        The server was updated. Save your work, then{" "}
        <button type="button" onClick={() => void forceUpdate()}>
          reload
        </button>
        .
      </div>
    );
  return (
    <div className="build-wall" role="alertdialog" aria-labelledby="build-wall-title">
      <div className="build-wall-card">
        <h2 id="build-wall-title">The game was updated</h2>
        {notice === "update" ? (
          <p>
            This version of the app is too old for the server. Update it from the store to play.
          </p>
        ) : (
          <>
            <p>The new version didn't load. Reload to continue.</p>
            <button
              type="button"
              onClick={() => {
                clearReloads(sessionStore()); // the player's own reload starts a fresh count
                void forceUpdate();
              }}
            >
              Reload
            </button>
          </>
        )}
      </div>
    </div>
  );
}
